<template>
  <div class="flex flex-col pb-4">
    <button
      v-for="preset of PERIOD_PRESETS"
      :key="preset.key"
      type="button"
      class="flex items-center gap-3 px-1 py-3 text-right border-b border-gray-100"
      @click="pickPreset(preset.key)"
    >
      <span class="flex-1 text-[14px]" :class="currentLabel === preset.label ? 'font-bold text-primary' : 'text-gray-800'">
        {{ preset.label }}
      </span>
      <i v-if="currentLabel === preset.label" class="pi pi-check text-sm text-primary"/>
    </button>

    <!-- custom range — picks in the shared settings date sheet -->
    <button
      type="button"
      class="flex items-center gap-3 px-1 py-3 text-right"
      @click="openCustom"
    >
      <span class="flex-1 text-[14px]" :class="isCustomActive ? 'font-bold text-primary' : 'text-gray-800'">
        טווח מותאם<template v-if="isCustomActive"> · {{ currentLabel }}</template>
      </span>
      <i class="pi pi-calendar text-sm text-gray-400"/>
    </button>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {DateTime} from 'luxon';
import {useDrawer} from '@torim-app/shared-components';

import SettingsDateSheet from '@app/components/admin/pages/configurations/ui/SettingsDateSheet.vue';
import {PERIOD_PRESETS, presetRange, type IPeriodRange, type PeriodPresetKey} from './period-presets';

const props = defineProps<{
  currentLabel?: string;
  customStart?: Date;
  customEnd?: Date;
  onPick: (range: IPeriodRange & { customStart?: Date; customEnd?: Date }) => void;
}>();

const {openDrawer, closeDrawer} = useDrawer();

const isCustomActive = computed(() =>
  !!props.currentLabel && !PERIOD_PRESETS.some(p => p.label === props.currentLabel));

const pickPreset = (key: PeriodPresetKey) => {
  props.onPick(presetRange(key));
  closeDrawer();
};

const openCustom = () => {
  openDrawer(SettingsDateSheet, {
    mode: 'range',
    startDate: props.customStart,
    endDate: props.customEnd,
    onPickRange: (pickedStart: Date, pickedEnd: Date) => {
      const start = DateTime.fromJSDate(pickedStart);
      const end = DateTime.fromJSDate(pickedEnd);
      props.onPick({
        startDate: start.toISODate() ?? '',
        endDate: end.toISODate() ?? '',
        label: `${start.toFormat('d.M')}–${end.toFormat('d.M')}`,
        customStart: pickedStart,
        customEnd: pickedEnd,
      });
      // closes the calendar (secondary); the date sheet's own closeDrawer that
      // runs right after then closes this picker (primary)
      closeDrawer();
    },
  }, {title: 'טווח תאריכים מותאם'});
};
</script>
